exports.fontFamilyDefault = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

exports.fontFamily = [];

exports.fontWeight = [
    { key: 'thin', value: '100' },
    { key: 'regular', value: '400' },
    { key: 'bold', value: '700' },
    { key: 'bolder', value: '900' }
];
